import { Link } from "react-router-dom";
import styled, { css, keyframes } from "styled-components";
import * as Ant from "antd";
const lineDraw = keyframes`
  from {
    stroke-dashoffset: 1;
  }

  to {
    stroke-dashoffset: 0;
  }
`;

const chartFadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;
const tapeScroll = keyframes`
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-33.333%);
  }
`;

export const Landing = styled.div`
  background-color: #000;
  padding: clamp(72px, 5.8vw, 90px) clamp(0.75rem, 3vw, 1.5rem) 1rem;
  color: white;
  overflow-x: hidden;

  @media screen and (max-width: 600px) {
    padding-top: clamp(68px, 17vw, 78px);
  }
`;

export const BrandLockup = styled.div`
  display: inline-flex;
  align-items: center;
  gap: clamp(12px, 1vw, 18px);
  min-width: 0;

  @media screen and (max-width: 600px) {
    gap: clamp(7px, 2.1vw, 10px);
  }
`;

export const BrandMark = styled.img`
  width: clamp(54px, 4.9vw, 70px);
  height: clamp(54px, 4.9vw, 70px);
  display: block;
  flex: 0 0 auto;

  @media screen and (max-width: 600px) {
    width: clamp(30px, 8.15vw, 36px);
    height: clamp(30px, 8.15vw, 36px);
  }
`;

export const Logo = styled.img`
  width: clamp(92px, 7.8vw, 120px);
  height: auto;
  display: block;
  flex: 0 1 auto;
  min-width: 0;

  @media screen and (max-width: 600px) {
    width: clamp(80px, 21vw, 94px);
  }

  @media screen and (max-width: 350px) {
    width: 76px;
  }
`;

export const StarLogo = styled.img`
  width: 100px;
`;

export const Header = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: min(calc(100% - clamp(1.5rem, 6vw, 3rem)), 1180px);
  padding: clamp(0.38rem, 0.9vw, 0.58rem) clamp(0.75rem, 2.2vw, 1.25rem);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  color: #fff;
  background: rgba(0, 0, 0, 0.72);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 0 0 16px 16px;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);

  > div:last-child {
    flex: 0 0 auto;
  }

  @media screen and (max-width: 600px) {
    width: calc(100% - 0.85rem);
    padding: 0.42rem 0.44rem;
    border-radius: 0 0 13px 13px;
    gap: 0.75rem;
  }
`;

export const Login = styled(Link)`
  color: #ffffff;
  font-size: clamp(0.74rem, 1.62vw, 0.96rem);
  font-weight: 600;
  white-space: nowrap;

  @media screen and (max-width: 380px) {
    font-size: 0.72rem;
  }
`;

export const SignUp = styled(Link)`
  background-color: #ffffff;
  color: #000000;
  padding: 0.46rem 0.72rem;
  border-radius: 8px;
  font-size: clamp(0.74rem, 1.62vw, 0.96rem);
  font-weight: 700;
  white-space: nowrap;

  @media screen and (max-width: 380px) {
    padding: 0.42rem 0.58rem;
    font-size: 0.72rem;
  }
`;

export const SectionOne = styled.section`
  width: min(100%, 1240px);
  margin: 0 auto;
  padding: clamp(3.25rem, 7vh, 5.4rem) clamp(1rem, 3vw, 2.5rem)
    clamp(1.35rem, 3.8vh, 2.45rem);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  h3 {
    width: min(100%, calc(100vw - 48px));
    max-width: min(1160px, calc(100vw - 48px));
    margin: 0 auto;
    font-family: "RiftonNorm", "Inter", sans-serif;
    color: #b7d8ff;
    font-size: clamp(3rem, 3.45vw, 3.85rem);
    font-weight: 800;
    line-height: 1.04;
    text-transform: uppercase;
    letter-spacing: 0;
    background: linear-gradient(
      171.12deg,
      #1871b6 -1.48%,
      #6fb1fc 13.55%,
      #c1d4e2 56.59%,
      #ebf4fb 122.07%
    );
    background-clip: text;
    color: transparent;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 0 0 18px rgba(44, 148, 223, 0.08);
    opacity: 0;
    transition: opacity 180ms ease;

    &.rifton-ready {
      opacity: 1;
    }

    .hero-line {
      display: block;
      white-space: nowrap;
    }

    .hero-amp {
      display: block;
      margin: 0.08em 0;
      color: #dcefff;
      font-size: 0.56em;
      line-height: 0.78;
      -webkit-text-fill-color: #dcefff;
    }
  }

  @media screen and (max-width: 600px) {
    box-sizing: border-box;
    padding-top: clamp(2.15rem, 5vh, 2.55rem);
    padding-right: 0;
    padding-bottom: clamp(0.75rem, 2vh, 1.05rem);
    padding-left: 0;

    h3 {
      box-sizing: border-box;
      width: 100%;
      max-width: 440px;
      padding-inline: 0.25rem;
      font-size: clamp(1.62rem, 6.9vw, 2.24rem);
      line-height: 1.055;

      .hero-line {
        white-space: normal;
      }

      .hero-line:first-child {
        white-space: nowrap;
        font-size: clamp(1.48rem, 6.65vw, 2.12rem);
        /* Rifton renders slightly wider in iOS Safari. Keep the one-line
           lockup while leaving a small safe edge on narrow iPhones. */
        letter-spacing: -0.03em;
      }


      .hero-amp {
        margin: 0.11em 0;
        font-size: 0.66em;
        line-height: 0.92;
      }
    }
  }

  @media screen and (max-width: 380px) {
    h3 {
      font-size: clamp(1.48rem, 6.55vw, 1.92rem);
    }
  }
`;

export const CreatorBtn = styled.button`
  min-width: min(100%, 360px);
  font-size: clamp(1.08rem, 1.4vw, 1.34rem);
  text-transform: uppercase;
  margin: clamp(1.7rem, 3.8vh, 2.45rem) 0 0;
  padding: 0.95rem 2.35rem;
  border: 0;
  border-radius: 60px;
  color: #ffffff;
  background: linear-gradient(
    90.08deg,
    #0d6ac3 1.6%,
    #0d6ac3 1.61%,
    rgba(201, 124, 199, 0.990267) 58.35%,
    rgba(207, 125, 199, 0.99) 58.36%,
    rgba(249, 143, 18, 0.99) 98.79%,
    rgba(253, 145, 1, 0.99) 102.66%
  );
  box-shadow: 0 16px 38px rgba(13, 106, 195, 0.2);
  cursor: pointer;
  font-weight: 800;

  @media screen and (max-width: 600px) {
    width: min(calc(100% - 5.25rem), 292px);
    min-width: 0;
    margin-top: clamp(1.85rem, 4.3vh, 2.15rem);
    font-size: clamp(0.9rem, 3.35vw, 1.04rem);
    padding: 0.78rem 1.25rem;
  }
`;

export const HeroCopy = styled.div`
  width: min(100%, 700px);
  margin: clamp(1.45rem, 3.2vh, 2.1rem) auto 0;
  color: #ffffff;
  font-family: "Inter", sans-serif;

  strong {
    display: block;
    font-size: clamp(1.16rem, 1.42vw, 1.48rem);
    font-weight: 700;
    line-height: 1.22;
  }

  p {
    margin: clamp(0.62rem, 1.55vh, 0.95rem) auto 0;
    max-width: 560px;
    color: rgba(255, 255, 255, 0.92);
    font-size: clamp(1.02rem, 1.24vw, 1.28rem);
    font-weight: 600;
    line-height: 1.18;
  }

  @media screen and (max-width: 600px) {
    width: min(calc(100vw - 28px), 370px);
    max-width: min(calc(100vw - 28px), 370px);
    margin-top: clamp(1.18rem, 3vh, 1.45rem);

    strong {
      font-size: clamp(0.84rem, 3.35vw, 1rem);
      line-height: 1.2;
    }

    p {
      max-width: 330px;
      margin-top: clamp(0.42rem, 1.35vh, 0.62rem);
      font-size: clamp(0.8rem, 3.28vw, 0.92rem);
      line-height: 1.08;
    }
  }
`;

const getReelScale = (offset: number) => {
  const absOffset = Math.abs(offset);
  if (absOffset === 0) return 1.16;
  if (absOffset === 1) return 0.86;
  return 0.7;
};

const getReelOpacity = (offset: number) => {
  const absOffset = Math.abs(offset);
  if (absOffset === 0) return 1;
  if (absOffset === 1) return 0.86;
  return 0.62;
};


export const FeatureTape = styled.div`
  width: min(100%, 760px);
  margin: clamp(1.1rem, 2.65vh, 1.65rem) auto 0;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.065);
  border-radius: 999px;
  background: rgba(54, 54, 57, 0.72);
  box-shadow: 0 7px 18px rgba(0, 0, 0, 0.14);
  transform: rotate(-0.75deg);
  transform-origin: center;

  mask-image: linear-gradient(90deg, transparent 0, #000 5%, #000 95%, transparent 100%);
  -webkit-mask-image: linear-gradient(90deg, transparent 0, #000 5%, #000 95%, transparent 100%);

  @media screen and (max-width: 600px) {
    width: min(calc(100vw - 1rem), 380px);
    margin-left: auto;
    margin-right: auto;
    margin-top: clamp(1rem, 2.45vh, 1.22rem);
    border-radius: 18px;
    transform: rotate(-1deg);
  }
`;

export const FeatureTapeTrack = styled.div`
  display: flex;
  width: max-content;
  animation: ${tapeScroll} 34s linear infinite;

  span {
    flex: 0 0 auto;
    padding: 0.32rem 1.35rem;
    color: #ffffff;
    font-family: "Inter", "Noto Sans", sans-serif;
    font-size: clamp(0.7rem, 1vw, 0.8rem);
    font-weight: 700;
    line-height: 1;
    letter-spacing: 0;
    word-spacing: 0.12rem;
    white-space: nowrap;
  }

  @media screen and (max-width: 600px) {
    animation-duration: 24s;

    span {
      padding: 0.44rem 1.15rem;
      font-size: clamp(0.68rem, 2.75vw, 0.76rem);
      line-height: 1;
      text-align: center;
      white-space: nowrap;
      word-spacing: 0.12rem;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
export const HeroReelShowcase = styled.div`
  position: relative;
  width: min(100%, 780px);
  height: clamp(250px, 34vh, 430px);
  margin: clamp(1.85rem, 4vh, 2.65rem) auto 0;
  overflow: hidden;
  touch-action: pan-y;

  @media screen and (min-width: 900px) {
    width: min(100%, 1060px);
    height: clamp(390px, 45vh, 560px);
  }

  @media screen and (max-width: 600px) {
    width: 100vw;
    height: clamp(188px, 25.2vh, 238px);
    margin-top: clamp(1.45rem, 3.4vh, 1.75rem);
  }

  @media screen and (max-width: 380px) {
    height: clamp(168px, 23.2vh, 204px);
  }
`;

export const HeroReel = styled.div<{ $offset: number; $active: boolean }>`
  position: absolute;
  top: 8%;
  left: 50%;
  width: clamp(92px, 24vw, 178px);
  aspect-ratio: 9 / 14;
  border-radius: 8px;
  overflow: hidden;
  background: #111111;
  transform: translateX(calc(-50% + ${({ $offset }) => $offset * 126}px))
    scale(${({ $offset }) => getReelScale($offset)});
  opacity: ${({ $offset }) => getReelOpacity($offset)};
  z-index: ${({ $offset }) => 10 - Math.abs($offset)};
  box-shadow: ${({ $active }) =>
    $active
      ? "0 24px 56px rgba(0, 0, 0, 0.58), 0 0 0 1px rgba(255,255,255,0.15)"
      : "0 14px 30px rgba(0, 0, 0, 0.42)"};
  transition:
    transform 540ms cubic-bezier(0.65, 0, 0.35, 1),
    opacity 540ms cubic-bezier(0.65, 0, 0.35, 1),
    box-shadow 540ms cubic-bezier(0.65, 0, 0.35, 1);
  will-change: transform, opacity;

  @media screen and (min-width: 900px) {
    width: clamp(200px, 18.5vw, 252px);
    border-radius: 10px;
    transform: translateX(calc(-50% + ${({ $offset }) => $offset * 208}px))
      scale(${({ $offset }) => getReelScale($offset)});
  }

  @media screen and (max-width: 420px) {
    top: 4%;
    width: clamp(87px, 24.2vw, 107px);
    transform: translateX(calc(-50% + ${({ $offset }) => $offset * 84}px))
      scale(${({ $offset }) => getReelScale($offset)});
  }

  @media screen and (min-width: 421px) and (max-width: 600px) {
    width: clamp(97px, 22.7vw, 119px);
    transform: translateX(calc(-50% + ${({ $offset }) => $offset * 94}px))
      scale(${({ $offset }) => getReelScale($offset)});
  }
`;

export const HeroReelVideo = styled.video`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const SectionTwo = styled.div`
  margin-top: 10rem;

  h3 {
    margin-bottom: 5rem;
  }
  @media screen and (max-width: 600px) {
    margin-top: 5rem;
  }
`;

export const SubHeading = styled.h3`
  text-transform: uppercase;
  text-align: center;
  font-weight: 800;
  font-size: clamp(2.58rem, 3.82vw, 3.05rem);
  line-height: 1.04;
  margin-bottom: 0;

  @media screen and (max-width: 600px) {
    font-size: clamp(1.88rem, 7.9vw, 2.42rem);
    line-height: 1;
    padding: 0 0.35rem;
  }
`;

export const ViewProfileBtn = styled.button`
  background-color: #d9d9d9;
  box-shadow: 0px 1.167492151260376px 1.167492151260376px 0px #00000040 inset;
  color: #000000;
  padding: 0.3rem 0.6rem;
  border-radius: 4px;
`;

export const CardWrapper = styled.div`
  min-height: 850px;
  width: 1500px;
  max-width: 90%;
  margin: auto;
  overflow: hidden;
  position: relative;

  @media screen and (max-width: 768px) {
    min-height: 650px;
  }

  .famous-user-card {
    position: absolute;
  }

  .card-2,
  .card-4 {
    height: 600px;
  }

  .card-1 {
    top: 0;
    left: 0;
  }

  .card-2 {
    top: 136px;
    left: 280px;
    z-index: 2;
  }

  .card-3 {
    top: 200px;
    height: 650px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5;
  }

  .card-4 {
    top: 136px;
    right: 280px;
    z-index: 2;
  }

  .card-5 {
    top: 0;
    right: 0;
  }

  .slider-container {
    display: none;
  }

  @media screen and (max-width: 1400px) {
    .famous-user-card {
      /* width: 300px; */
      /* height: 500px; */
    }

    .card-4 {
      right: 150px;
    }

    .card-2 {
      left: 150px;
    }
  }

  @media screen and (max-width: 768px) {
    .famous-user-card {
      width: 250px !important;
      height: 500px !important;
    }

    .card-4 {
      right: 120px;
    }

    .card-2 {
      left: 120px;
    }

    .card-3 {
      top: 120px;
    }

    .card-2,
    .card-4 {
      top: 75px;
    }
  }

  @media screen and (max-width: 980px) {
    .famous-user-card {
      width: 250px !important;
      height: 460px !important;
    }
  }

  @media screen and (max-width: 870px) {
    .slider-container {
      display: block;
    }

    .card-container {
      display: none;
    }

    min-height: unset;
  }
`;

export const Card = styled.div`
  height: 600px;
  width: 350px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
`;

export const CardContent = styled.div`
  position: absolute;
  bottom: 1.5rem;
  left: 1.5rem;
  width: 100%;
  h5 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }

  .followers-box {
    span {
      font-size: 14px;
    }
  }
`;

export const CardImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const CardVideo = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const SectionThree = styled.div`
  h3 {
    margin-top: clamp(2.25rem, 5.7vw, 4.45rem);
  }

  @media screen and (max-width: 600px) {
    margin-top: clamp(0.7rem, 3.1vw, 1.2rem);

    h3 {
      margin-top: 0;
    }
  }
`;

export const SecThreeImg = styled.img`
  width: 1000px;
  object-fit: contain;
  margin: auto;
  max-width: 90%;
  aspect-ratio: 1/1;

  @media screen and (max-width: 600px) {
    width: min(100%, 420px);
    max-width: 100%;
    margin-top: 0.75rem;
  }
`;

export const SectionFour = styled.div`
  margin-top: clamp(3.05rem, 6.4vw, 4.95rem);

  h3 {
    margin-bottom: clamp(2.65rem, 5.3vw, 4.45rem);
  }

  @media screen and (max-width: 600px) {
    margin-top: clamp(2.45rem, 9.2vw, 3.55rem);
    padding: 0 0.35rem;

    h3 {
      margin-bottom: clamp(1.85rem, 7vw, 2.62rem);
    }
  }
`;

export const SectionFlex = styled.div`
  display: flex;
  flex-direction: column;
  width: min(92%, 600px);
  margin: auto;
  align-items: center;
  justify-content: center;
  gap: clamp(0.9rem, 2.4vw, 1.2rem);

  @media screen and (max-width: 600px) {
    width: min(100%, 370px);
  }
`;

export const EarningsCard = styled.div`
  position: relative;
  width: min(100%, 560px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.11);
  border-radius: 22px;
  padding: clamp(1.05rem, 2.6vw, 1.55rem);
  background:
    linear-gradient(145deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.028) 52%, rgba(255, 143, 31, 0.045)),
    #090909;
  box-shadow:
    0 20px 58px rgba(0, 0, 0, 0.46),
    0 0 0 1px rgba(255, 255, 255, 0.035) inset;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1px;
    background: linear-gradient(135deg, rgba(35, 135, 255, 0.52), rgba(216, 136, 232, 0.18), rgba(255, 148, 31, 0.48));
    mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    mask-composite: exclude;
    -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    -webkit-mask-composite: xor;
    pointer-events: none;
  }

  @media screen and (max-width: 600px) {
    border-radius: 20px;
    padding: clamp(0.95rem, 4.4vw, 1.2rem);
  }
`;
export const EarningsCardHeader = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  color: rgba(255, 255, 255, 0.7);
  font-family: "Inter", sans-serif;
  font-size: clamp(0.92rem, 1.6vw, 1.05rem);
  font-weight: 700;

  @media screen and (max-width: 420px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.65rem;
  }
`;

export const GrowthChip = styled.span`
  flex: 0 0 auto;
  border: 1px solid rgba(116, 255, 182, 0.26);
  border-radius: 999px;
  padding: 0.42rem 0.68rem;
  color: #9effca;
  background: rgba(49, 255, 145, 0.08);
  font-size: 0.78rem;
  line-height: 1;
  box-shadow: 0 0 24px rgba(75, 255, 162, 0.08);
`;

export const EarningsValue = styled.div`
  position: relative;
  z-index: 1;
  margin-top: clamp(0.82rem, 2.1vw, 1.1rem);
  font-family: "Inter", "Noto Sans", sans-serif;
  font-size: clamp(2.45rem, 6.4vw, 4.35rem);
  font-weight: 820;
  line-height: 0.95;
  letter-spacing: -0.02em;
  color: #ffffff;
  font-variant-numeric: tabular-nums;

  @media screen and (max-width: 600px) {
    font-size: clamp(2.16rem, 10.2vw, 2.92rem);
  }
`;
export const LineChart = styled.div<{ $active: boolean }>`
  position: relative;
  z-index: 1;
  margin-top: clamp(1rem, 2.5vw, 1.4rem);
  padding: clamp(0.62rem, 1.8vw, 0.9rem);
  border-radius: 18px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.055), rgba(255, 255, 255, 0.022)),
    rgba(255, 255, 255, 0.025);
  border: 1px solid rgba(255, 255, 255, 0.07);

  svg {
    display: block;
    width: 100%;
    height: clamp(120px, 19vw, 165px);
    overflow: visible;
  }

  .stats-area {
    fill: url(#statsAreaGradient);
    opacity: ${({ $active }) => ($active ? 1 : 0)};
    animation: ${({ $active }) =>
      $active
        ? css`${chartFadeUp} 720ms ease-out 240ms both`
        : "none"};
  }

  .stats-line {
    fill: none;
    stroke: url(#statsLineGradient);
    stroke-width: 5.5;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 1;
    stroke-dashoffset: ${({ $active }) => ($active ? 0 : 1)};
    filter: drop-shadow(0 0 8px rgba(79, 151, 255, 0.22));
    animation: ${({ $active }) =>
      $active
        ? css`${lineDraw} 1150ms cubic-bezier(0.22, 0.75, 0.18, 1) both`
        : "none"};
  }

  .stats-dot {
    fill: #ffffff;
    opacity: ${({ $active }) => ($active ? 1 : 0)};
    filter: drop-shadow(0 0 9px rgba(255, 148, 31, 0.32));
    transition: opacity 220ms ease 920ms;
  }

  @media screen and (max-width: 600px) {
    border-radius: 16px;

    svg {
      height: clamp(110px, 30vw, 134px);
    }

    .stats-line {
      stroke-width: 5;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .stats-area,
    .stats-line {
      animation: none;
    }

    .stats-line {
      stroke-dashoffset: 0;
    }

    .stats-area,
    .stats-dot {
      opacity: 1;
    }
  }
`;

export const StatsFeatureGrid = styled.div`
  width: min(100%, 520px);
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.62rem;

  @media screen and (max-width: 600px) {
    width: min(100%, 348px);
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.58rem;
  }
`;

export const StatsFeature = styled.div`
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.62rem 0.7rem;
  border-radius: 13px;
  border: 1px solid rgba(255, 255, 255, 0.09);
  background: rgba(255, 255, 255, 0.045);
  color: rgba(255, 255, 255, 0.84);
  font-family: "Inter", "Noto Sans", sans-serif;
  font-size: clamp(0.78rem, 1.35vw, 0.9rem);
  font-weight: 650;
  line-height: 1.15;
  text-align: center;

  @media screen and (max-width: 600px) {
    min-height: 44px;
    font-size: 0.82rem;
  }
`;
export const FaqWrapper = styled.div`
  margin-top: clamp(5.4rem, 9vw, 7.15rem);
  h3 {
    margin-bottom: 2.65rem;
  }

  @media screen and (max-width: 600px) {
    margin-top: clamp(3.8rem, 14vw, 5.25rem);
    padding-bottom: 1.25rem;

    h3 {
      font-size: clamp(1.66rem, 6.75vw, 2.05rem);
      line-height: 1.02;
      margin-bottom: clamp(1.58rem, 6.2vw, 2.25rem);
    }
  }
`;

export const CollaspeWrapper = styled.div`
  width: 1000px;
  max-width: 90%;
  margin: auto;
`;

export const Collapse = styled(Ant.Collapse)`
  border: none !important;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  .ant-collapse-header {
    background-color: #1d1d1d;
    color: white !important;
    padding: 1rem 16px !important;
  }

  .ant-collapse-item {
    border: none !important;
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-collapse-content-box {
    background-color: #1d1d1d;
    color: white !important;
  }

  .ant-collapse-content-active {
    border-top: 1px solid #353535 !important;
  }

  @media screen and (max-width: 600px) {
    gap: 0.75rem;

    .ant-collapse-header {
      padding: 0.9rem 0.9rem !important;
      font-size: 0.95rem;
      line-height: 1.25;
    }

    .ant-collapse-content-box {
      font-size: 0.92rem;
      line-height: 1.45;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 200px;
  background: linear-gradient(180deg, #131313 0%, #000000 100%);
  padding: 0 5rem;
  margin-top: 4rem;

  @media screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.85rem;
    height: unset;
    padding: 1.25rem 1.5rem 0.25rem;
  }
`;

export const FooterItem = styled(Link)`
  font-size: 1.4rem;
  letter-spacing: 0.1rem;
  font-weight: bold;
  text-transform: uppercase;
  @media screen and (max-width: 600px) {
    display: block;
    margin-bottom: 0;
    font-size: 1rem;
    line-height: 1.2;
  }
`;

export const CarouselWrapper = styled.div`
  width: 100%;
  outline: none !important;
`;

const carouselMediaStyles = css`
  object-fit: cover;
  border-radius: 20px;
  width: calc(100% - 1rem);
  height: 600px;
  max-height: 70vh;
  margin: auto;
  @media screen and (max-width: 600px) {
    max-height: 50vh;
  }
`;

export const CarouselImg = styled.img`
  ${carouselMediaStyles}
`;

export const CarouselVideo = styled.video`
  ${carouselMediaStyles}
`;
